<div class="mt-5">
  <div class="card">
    <div class="row">
      <div class="col">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <h1 class="section-title">{{ 'CAPITAL.Title' | labelText }}</h1>
            </div>
          </div>

          <div class="row">
            <form [formGroup]="form" *ngIf="form">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                <app-dropdown-form-control
                  [parentForm]="form"
                  [formControlName]="'gpaCapitals'"
                  (onChanged)="recalculateRate()"
                  [title]="''"
                  class="no-title"
                >
                </app-dropdown-form-control>
              </div>
            </form>
          </div>

          <app-view-offer
            [clientProfile]="clientProfileForViewOffer"
            [pageName]="constants.pages.capital.name"
            (onOffersCountChanged)="onOffersCountChanged($event)"
          ></app-view-offer>

          <div class="row" *ngIf="ageLessOrEqualPivot && gpaCapitalLimits">
            <div class="col-xs-12 col-sm-12 col-md-8 col-lg-7">
              <div class="col-speech">
                <p class="mb-0">
                  <mat-checkbox
                    [(ngModel)]="x2x3Model"
                    [disabled]="!isCapitalLessOrEqualMaxX2X3"
                    (ngModelChange)="recalculateRate()"
                  >
                    <span
                      [class.disabled-text]="!isCapitalLessOrEqualMaxX2X3"
                      class="text-blue fs-18 fw-600"
                    >
                      {{
                        'CAPITAL.ATDNUnder60GuaranteeX2X3Checkbox' | labelText
                      }}
                    </span>
                  </mat-checkbox>
                </p>
                <p
                  class="txt-default"
                  [class.disabled]="!isCapitalLessOrEqualMaxX2X3"
                  *ngIf="
                    !gpaCapitalsControl.value || !isCapitalLessOrEqualMaxX2X3
                  "
                >
                  {{
                    'CAPITAL.ATDNGaranteeX2X3DescriptionNoSelection1'
                      | labelText
                  }}
                  {{ capitalChoisedOrMaxX2X3 | euro : true }}
                  {{
                    'CAPITAL.ATDNGaranteeX2X3DescriptionNoSelection2'
                      | labelText
                  }}
                  {{ capitalChoisedOrMaxX2X3 * 2 | euro : true }}
                  {{
                    'CAPITAL.ATDNGaranteeX2X3DescriptionNoSelection3'
                      | labelText
                  }}
                  {{ capitalChoisedOrMaxX2X3 * 3 | euro : true }}.
                  <span
                    *ngIf="isCapitalLessOrEqualMaxX2X3"
                    class="link-like text-blue"
                    (click)="x2x3ReadMoreClick()"
                    >{{ 'CAPITAL.ATDNGuaranteeX2X3Link' | labelText }}</span
                  >
                  <span *ngIf="!isCapitalLessOrEqualMaxX2X3">{{
                    'CAPITAL.ATDNGuaranteeX2X3Link' | labelText
                  }}</span>
                </p>
                <p
                  class="txt-default"
                  *ngIf="
                    gpaCapitalsControl.value && isCapitalLessOrEqualMaxX2X3
                  "
                >
                  {{
                    'CAPITAL.ATDNGaranteeX2X3DescriptionWithSelection1'
                      | labelText
                  }}
                  <span class="fw-600">
                    {{
                      'CAPITAL.ATDNGaranteeX2X3DescriptionWithSelection2'
                        | labelText
                    }}
                    {{ capitalChoisedOrMaxX2X3 * 2 | euro : true }}
                  </span>
                  {{
                    'CAPITAL.ATDNGaranteeX2X3DescriptionWithSelection3'
                      | labelText
                  }}
                  <span class="fw-600">
                    {{
                      'CAPITAL.ATDNGaranteeX2X3DescriptionWithSelection4'
                        | labelText
                    }}
                    {{ capitalChoisedOrMaxX2X3 * 3 | euro : true }}.
                  </span>
                  <span
                    class="link-like text-blue"
                    (click)="x2x3ReadMoreClick()"
                    >{{ 'CAPITAL.ATDNGuaranteeX2X3Link' | labelText }}</span
                  >
                </p>
              </div>
            </div>
          </div>

          <div
            class="row text-left mb-3"
            *ngIf="ageLessOrEqualPivot && gpaCapitalLimits"
          >
            <div class="col-xs-12 col-sm-12 col-md-8 col-lg-7">
              <span class="text-blue fs-18 fw-600">
                {{ 'CAPITAL.ATDNUnder60Included' | labelText }}
              </span>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-8 col-lg-7">
              <p class="txt-default">
                {{ 'CAPITAL.ATDNServicesDescription' | labelText }}
                <span
                  class="link-like text-blue"
                  (click)="inclusLesServicesClick()"
                  >{{ 'CAPITAL.ATDNServicesLink' | labelText }}</span
                >
              </p>
            </div>
          </div>

          <div
            class="text-left"
            *ngIf="!ageLessOrEqualPivot && gpaCapitalLimits"
          >
            <div class="row mt-4 mb-2">
              <div class="col-xs-12 col-sm-12 col-md-8 col-lg-7">
                <h4 class="fw-600">
                  {{ 'CAPITAL.ATDNPlus60Included' | labelText }}
                </h4>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-xs-12 col-sm-12 col-md-8 col-lg-7">
                <span class="text-blue fs-18 fw-600">
                  {{ 'CAPITAL.ATDNPlus60GuaranteeX2X3Title' | labelText }}
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-8 col-lg-7">
                <p
                  class="txt-default"
                  *ngIf="
                    !gpaCapitalsControl.value || !isCapitalLessOrEqualMaxX2X3
                  "
                >
                  {{
                    'CAPITAL.ATDNGaranteeX2X3DescriptionNoSelection1'
                      | labelText
                  }}
                  {{ capitalChoisedOrMaxX2X3 | euro : true }})
                  {{
                    'CAPITAL.ATDNGaranteeX2X3DescriptionNoSelection2'
                      | labelText
                  }}
                  {{ capitalChoisedOrMaxX2X3 * 2 | euro : true }})
                  {{
                    'CAPITAL.ATDNGaranteeX2X3DescriptionNoSelection3'
                      | labelText
                  }}
                  {{ capitalChoisedOrMaxX2X3 * 3 | euro : true }}).
                  <span
                    class="link-like text-blue"
                    (click)="x2x3ReadMoreClick()"
                    >{{ 'CAPITAL.ATDNGuaranteeX2X3Link' | labelText }}</span
                  >
                </p>
                <p
                  class="txt-default"
                  *ngIf="
                    gpaCapitalsControl.value && isCapitalLessOrEqualMaxX2X3
                  "
                >
                  {{
                    'CAPITAL.ATDNGaranteeX2X3DescriptionWithSelection1'
                      | labelText
                  }}
                  <span class="fw-600">
                    {{
                      'CAPITAL.ATDNGaranteeX2X3DescriptionWithSelection2'
                        | labelText
                    }}
                    {{ capitalChoisedOrMaxX2X3 * 2 | euro : true }}
                  </span>
                  {{
                    'CAPITAL.ATDNGaranteeX2X3DescriptionWithSelection3'
                      | labelText
                  }}
                  <span class="fw-600">
                    {{
                      'CAPITAL.ATDNGaranteeX2X3DescriptionWithSelection4'
                        | labelText
                    }}
                    {{ capitalChoisedOrMaxX2X3 * 3 | euro : true }}.
                  </span>
                  <span
                    class="link-like text-blue"
                    (click)="x2x3ReadMoreClick()"
                    >{{ 'CAPITAL.ATDNGuaranteeX2X3Link' | labelText }}</span
                  >
                </p>
              </div>
            </div>
            <div class="row mb-2 mt-4">
              <div class="col-xs-12 col-sm-12 col-md-8 col-lg-7">
                <span class="text-blue fs-18 fw-600">
                  {{ 'CAPITAL.ATDNPlus60ServicesTitle' | labelText }}
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-8 col-lg-7">
                <p class="txt-default">
                  {{ 'CAPITAL.ATDNServicesDescription' | labelText }}
                  <span
                    class="link-like text-blue"
                    (click)="inclusLesServicesClick()"
                    >{{ 'CAPITAL.ATDNServicesLink' | labelText }}</span
                  >
                </p>
              </div>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col">
              <div class="recap">
                <div
                  class="recap-gpa-profile"
                  [class.no-bord-bot-rad]="isShowDiagram"
                >
                  <div class="title">
                    <div class="mb-2">
                      <h1 class="fw-600">
                        {{ 'CAPITAL.PriceNoSelectionTitle1' | labelText }}
                        <span *ngIf="planDetails"
                          >{{ 'CAPITAL.PriceNoSelectionTitle2' | labelText }}
                          {{ planDetails.mntCapital | euro }}</span
                        >
                      </h1>
                    </div>
                    <h1 class="fw-600">
                      <div *ngIf="planDetails">
                        {{ 'CAPITAL.PriceNoSelectionTitle3' | labelText }}
                        {{ planDetails.cotisation[0].mntCotisation | euro }} /
                        mois
                      </div>
                    </h1>
                  </div>
                  <div class="content">
                    <p>
                      <span *ngIf="!planDetails" class="fs-16">
                        <br />
                        <span
                          [innerHTML]="
                            'CAPITAL.PriceATDNNoSelectionContent' | labelText
                          "
                        >
                        </span>
                      </span>
                      <span *ngIf="planDetails" class="fs-16">
                        <br />{{
                          'CAPITAL.PriceATDNWithSelectionContent' | labelText
                        }}
                        <br /><br />
                        <span
                          (click)="showDiagram()"
                          class="link-like fs-14 fw-600"
                          >{{ 'CAPITAL.PriceScaleShow' | labelText }}
                        </span>
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              <div class="recap" *ngIf="isShowDiagram">
                <div class="recap-gpa-diagram">
                  <div class="row">
                    <div class="col">
                      <div class="section-diagram-title">
                        {{ 'CAPITAL.PriceScaleTitle' | labelText }}
                        <app-tooltip
                          [title]="'CAPITAL.PriceScaleTitle' | labelText"
                          [text]="'CAPITAL.PriceScaleTooltipText' | labelText"
                          [tooltipPosition]="'bottom'"
                        >
                        </app-tooltip>
                        <a
                          class="red-link text-blue mt-0"
                          href="javascript:void(0)"
                          (click)="hideDiagram()"
                        >
                          {{ 'CAPITAL.PriceScaleHide' | labelText }}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div *ngIf="chartData">
                      <canvas
                        baseChart
                        [type]="'line'"
                        [data]="chartData"
                        [options]="chartOptions"
                      ></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-4">
                <div class="col">
                  <div class="valider-button-block">
                    <button
                      type="submit"
                      (click)="submit()"
                      [disabled]="form.invalid"
                      class="btn btn-blue valider"
                    >
                      {{ 'Common.Validate' | labelText }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
